import { z } from 'zod';

/** Marché (`data-model.md` § `markets`) : `en-US`, `fr-FR` en V0. Les constantes fournisseur restent côté serveur. */
export const Market = z.object({
  id: z.string(),
  languageCode: z.string(),
  countryCode: z.string(),
  currency: z.string(),
  enabled: z.boolean(),
});
export type Market = z.infer<typeof Market>;

/** `GET /markets` : marchés activés. */
export const MarketsResponse = z.object({ items: z.array(Market) });
export type MarketsResponse = z.infer<typeof MarketsResponse>;
